import { css } from 'styled-components';
import {
  getSpacing, SpacingName, getTypography, TypographyName, ThemedFunctor,
} from '@doveit/lego';

export const base = css`
  width: 100%;
`;

export const item = css`
  align-items: center;
  display: flex;
  height: 3.125rem;
`;

export const term: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.BODY)};
  ${getSpacing.paddingRight(theme, SpacingName.SMALLER)}
  font-weight: 700;

  &:after {
    content: ":"
  }
`;

export const description: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.BODY)};
`;
